var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"viewBox":"0 0 1000 1000"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }